import { SET_MODEL } from './names';

export const setModel = model => ({
  type: SET_MODEL,
  model,
});
